import React from "react";

/**
 * PageLoader — a full-viewport friendly spinner shown while a page bootstraps.
 * NEVER return `null` from a page while data is loading — on mobile the user
 * sees a fully black screen and thinks the site broke. Use this instead.
 */
export default function PageLoader({ label = "Loading the Vault…" }) {
  return (
    <div
      data-testid="page-loader"
      className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[var(--av-bg)] px-4 pb-[env(safe-area-inset-bottom)]"
    >
      <div className="w-12 h-12 rounded-full border-2 border-[var(--av-border)] border-t-[var(--av-gold)] animate-spin" />
      <div className="text-sm text-[var(--av-text-dim)] font-mono">{label}</div>
    </div>
  );
}
